export default "__VITE_ASSET__ss$HuxBW__"